<div class="app-shell">
  @if (!isImmersiveRoute()) {
    <app-header />
  }
  <div class="app-route-content">
    <router-outlet />
  </div>
  @if (!isImmersiveRoute()) {
    <app-footer />
  }
</div>
